import React from 'react';
import { Section } from './ui/Section';
import { ShieldCheck, Clock, BrainCircuit } from 'lucide-react';
export function UniqueMechanism() {
  return <Section bg="navy" className="text-white relative overflow-hidden" data-id="element-177">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-amber/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-178"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/5 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-179"></div>

      <div className="relative z-10" data-id="element-180">
        <div className="text-center mb-16" data-id="element-181">
          <span className="text-amber font-bold tracking-wider text-sm uppercase mb-4 block" data-id="element-182">
            El Nuevo Paradigma
          </span>
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-183">
            Presentamos el{' '}
            <span className="text-amber" data-id="element-184">"Reset Táctico de 48 Horas"</span>
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto leading-relaxed" data-id="element-185">
            A diferencia de los métodos de entrenamiento estándar, este
            protocolo se basa en la gestión de los ciclos biológicos y
            metabólicos de tu cachorro.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-186">
          <div className="bg-white/5 border border-white/10 p-8 rounded-2xl backdrop-blur-sm" data-id="element-187">
            <div className="w-14 h-14 bg-amber/20 rounded-xl flex items-center justify-center mb-6" data-id="element-188">
              <BrainCircuit className="w-8 h-8 text-amber" data-id="element-189" />
            </div>
            <h3 className="text-xl font-bold mb-4" data-id="element-190">
              No "hablamos" con el perro
            </h3>
            <p className="text-white/70 leading-relaxed" data-id="element-191">
              Sincronizamos sus necesidades de sueño, eliminación y masticación
              con tu horario de vida.
            </p>
          </div>

          <div className="bg-white/5 border border-white/10 p-8 rounded-2xl backdrop-blur-sm" data-id="element-192">
            <div className="w-14 h-14 bg-amber/20 rounded-xl flex items-center justify-center mb-6" data-id="element-193">
              <Clock className="w-8 h-8 text-amber" data-id="element-194" />
            </div>
            <h3 className="text-xl font-bold mb-4" data-id="element-195">Ingeniería Conductual</h3>
            <p className="text-white/70 leading-relaxed" data-id="element-196">
              Es un sistema estructurado que convierte el instinto natural de tu
              perro en tu mejor aliado, en tiempo récord.
            </p>
          </div>

          <div className="bg-white/5 border border-white/10 p-8 rounded-2xl backdrop-blur-sm" data-id="element-197">
            <div className="w-14 h-14 bg-amber/20 rounded-xl flex items-center justify-center mb-6" data-id="element-198">
              <ShieldCheck className="w-8 h-8 text-amber" data-id="element-199" />
            </div>
            <h3 className="text-xl font-bold mb-4" data-id="element-200">Resultados Predecibles</h3>
            <p className="text-white/70 leading-relaxed" data-id="element-201">
              Al basarnos en biología y no en "trucos", eliminamos las
              conjeturas y garantizamos paz en tu hogar.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}